export const totalTaskSelector = (state) => state.taskExtraReducer.totalTask;
export const unfinishedTaskCountSelector = (state) =>
  state.taskExtraReducer.unfinishedTaskCount;
